import BaseApi from './BaseApi'

export default class TrackingApi extends BaseApi {
    async keepAliveConnection (connectionId) {
        return await this.get(`/api/v1.0/tracking/keepAlive/${connectionId}`);
    }
    async subscribe (connectionId, hardwareIds = []) {
        return await this.post('/api/v1.0/tracking/subscribe', {
            connectionId: connectionId,
            hardwareIds: hardwareIds
        })
    }
}
